import { ColorSplashStyled } from 'enrollment/features/Plans/LastYearBenefitsInOe/LastYearBenefitsInOeStyled';
import './CategoryColorSplash.css';

interface CategoryColorSplashProps {
  color: string;
}

export const CategoryColorSplash = ({ color }: CategoryColorSplashProps) => {
  const colorNum = color.replace('annotation', '');

  return (
    <div
      className="color-splash"
      data-testid={`bkg-img-${colorNum}`}
      style={{ backgroundColor: `var(--annotation-${colorNum})`, opacity: 0.1 }}
    >
      <ColorSplashStyled colorNum={colorNum} />
    </div>
  );
};
